import { color as fplColor } from '@figma/fpl-tokens/tokens.stylex';
import { Box } from '@/UI/Box/Box';
import { TextStdRg } from '@/UI/AppTypography/AppTypography';
import { color } from '@/colors';
import { useFplMigrationFlag } from '@/contexts/FplMigrationContext';
import { FPL_ICON_COLOR_VAR } from '@/UI/Icons/fplIcon';
import { WarningTriangleIcon } from '@/UI/Icons/WarningTriangleIcon';
import { FlexColCenHorVer } from '@/UI/styles';
import type { CSSProperties } from 'react';

function NodeErrorOverlay({ errorMessage }: { errorMessage: string }) {
  const isFpl = useFplMigrationFlag();

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: color.Black84_T,
        }}
      />
      <FlexColCenHorVer
        data-testid="error-container"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: color.Weavy_Error_08_T,
          borderRadius: 2,
        }}
      >
        <WarningTriangleIcon
          color={fplColor.textDanger}
          style={isFpl ? ({ [FPL_ICON_COLOR_VAR]: fplColor.iconDanger } as CSSProperties) : undefined}
        />
        <TextStdRg color={fplColor.textDanger} sx={{ width: '80%', textAlign: 'center', mt: 1 }}>
          {errorMessage}
        </TextStdRg>
      </FlexColCenHorVer>
    </>
  );
}

export default NodeErrorOverlay;
